// 动态创建aes 
var setLoadAes = function (ucresHost) {
	return new Promise(function(resolve, reject){ 
		if (window.CryptoJS && CryptoJS) {
			resolve({})
		} else {
			// 动态创建加密CryptoJS
      var script = document.createElement('script')
      script.type = 'text/javascript'
      script.src =  ucresHost + '/libs/cdn/crypto-js.js'
      document.getElementsByTagName('head')[0].appendChild(script)
      var timer = 0;
      script.onload = function () {
      	if (CryptoJS) {
      		resolve({})
      	} else {
      		timer = setInterval(function () {
      			if (CryptoJS) {
      				window.clearInterval(timer)
      				resolve({})
      			}
      		}, 5)
      	}
      }
      script.onerror = function() {
        reject({})
      }
		}
	})
}
export default setLoadAes


// WEBPACK FOOTER //
// ./src/loadAes.js